import { useMemo } from 'react'
import {
  paymentMethodsList,
  type PaymentMethodsType,
} from '@/constants/paymentMethods'
import { useGetWalletDataByCryptoCode } from './useGetWalletDataByCryptoCode'
import { getReferenceColorsForTheCurrency } from '@/utils/getReferenceColorsForTheCurrency'
import type { CryptoCode } from '@/constants/currencyCodes'

interface UseGetPaymentMethodsWithWalletProps {
  currencyCode: CryptoCode
}

export const useGetPaymentMethodsWithWallet = ({
  currencyCode,
}: UseGetPaymentMethodsWithWalletProps): PaymentMethodsType[] => {
  const walletData = useGetWalletDataByCryptoCode({ cryptoCode: currencyCode })

  const paymentMethodsWithWallet = useMemo(() => {
    if (!walletData) {
      return paymentMethodsList
    }

    // Create wallet payment method from wallet data
    const walletPaymentMethod: PaymentMethodsType = {
      id: 'wallet',
      name: 'Wallet',
      paymentMethod: 'Wallet',
      displayCurrencyCode: walletData.displayCurrencyCode || currencyCode,
      currencyName: walletData.name,
      currencyIconUrl: walletData.icon,
      currencyBgColor: Array.isArray(walletData.avatarBGRefColor)
        ? getReferenceColorsForTheCurrency({
            currencyCode: walletData.code,
          }).donutChartRefColor
        : walletData.avatarBGRefColor,
      formattedAmountBalance: walletData.formattedAmountBalance,
      iconName: 'wallet',
      iconSize: 32,
    }

    // Add wallet method to the beginning of the list
    return [walletPaymentMethod, ...paymentMethodsList]
  }, [walletData, currencyCode])

  return paymentMethodsWithWallet
}

export default useGetPaymentMethodsWithWallet
